import Collection from 'lib/client/collections/collection'

class AppointmentTypes extends Collection{
    create(options){
        return this.axios.post(`organizations/${this.props.currentOrganization.id}/appointment-types`, options);
    }
    update(options){
        const id = options.id
        delete options.id
        return this.axios.put(`organizations/${this.props.currentOrganization.id}/appointment-types/${id}`, options);
    }
    activate(options){
        return this.axios.put(`organizations/${this.props.currentOrganization.id}/appointment-types/activate`, options);
    }
    destroy(id){
        return this.axios.delete(`organizations/${this.props.currentOrganization.id}/appointment-types/${id}`);
    }
    fetch(options = {}){
        return this.axios.get(`organizations/${this.props.currentOrganization.id}/appointment-types`, options);
    }
}

export default AppointmentTypes;